export const computerDesign =[
  {
    "name": "基于vue的音乐播放系统(论文+PPT)",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java财会信息管理系统的分析",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学志愿填报系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于司机信用评价的货运管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java沉浸式戏曲文化体验系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的学院教学工作量统计系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的二手闲置交易系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "半成品配菜平台设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校内跑腿业务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的智慧物业服务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "G县乡村生活垃圾治理问题中运输地图",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "酷听音乐",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的自习室座位预约系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java Move体育商城",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的遥感影像共享系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java教务管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot和vue的课程教学平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot+vue框架的企业人事管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "爬虫基于网页开发和数据抓取技术的在线新闻聚合平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "c语言学习辅导网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的个性化音乐推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上书店",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java视频点播系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "玩具租赁系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java办公用品管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于 Javaweb 的二手图书交易系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java农场投入品运营线上管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "《计算机基础》网上考试系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校大学生竞赛项目管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "湖南交通工程学院学生就业信息系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java美妆神域",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生就业信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的小区停车场管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "饮食营养管理信息系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "J2EE在在线项目管理与任务分配中的应用",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的小区运动中心预约管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java基于高性能计算中心的高性能集群共享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的中医院问诊系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java教师科研管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot框架的网上蛋糕销售系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校学术交流平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的养老院管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医学电子技术线上翻转课堂系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot vue的学院网站系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线问诊系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的公寓出租系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaWeb的毕业季旅游一站式定制服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot心理健康服务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java物业智慧系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的苏蔚家校互联管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能推荐旅游平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java株洲崔氏服装有限公司服装生产管理信息系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "某炼油厂盲板管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "零食批发商仓库管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java WEB旅游门票信息系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医疗废物管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "東耳篮球馆会员信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java邢台市桥东区社区停车信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的网上订餐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java线上一流课程教学辅助系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能健康饮食系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的校园消费点评系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的学生作业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot的校园服务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java Web的租房管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java线上一流课程教学辅助系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java兰州市出租车服务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的商城积分系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的电缆行业生产管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "房屋租赁系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于智慧校园的大学生综合能力测评系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个性化推荐影院",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的小型民营加油站管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java家政预约平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生志愿者信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的特殊儿童家长教育能力提升平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的农业收成管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java物业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的实验室开放管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "垃圾分类回收管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java宠物管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java旅游攻略平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的景区管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java面向社区的智能化健康管理系统研究",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java人事档案管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java个性化智能学习系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java社区智慧医疗养老系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宾馆客房管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线学习平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java牧民画像系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java高校实验室智能管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "民宿管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的资源分享系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校学生求职就业平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java小区闲置物品交易网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue框架的学生交流互助平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java付费自习室管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java在线考试系统(论文+PPT)",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的本科实践教学管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的房屋租赁管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宿舍报修系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java百货中心管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "踏雪阁民宿订购平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的中药材管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的实验报告系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java大学生校园线上招聘系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校外兼职教师考勤管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java基于云平台的信息安全攻防实训平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot Vue的家具商城系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校友录管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生报名管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java家校合作平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java“课件通”中小学教学课件共享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot+vue的大学生创业项目的信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java农产品系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java技术的救灾物资调动系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaWeb的教务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园论坛系统(论文+PPT)",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java教务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "竞赛管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java房屋系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java大学生创新能力培养平台的设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生竞赛管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Cloud技术的智慧云停车场服务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Spring Boot构建的金雁在线考试系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的渔具管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "数字资源共享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaScript的在线考试系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "亚运会志愿者管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的电影院售票管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot房屋买卖平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "英语学习平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java校园志愿者服务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的社区流浪动物救助系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农产品销售系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "毕业生追踪系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的德百商城停车场管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "闲置物品交易网站设计与实现(论文+PPT)",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot4S店车辆管理系统(论文+PPT)",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "交通感知与车路协同系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "spring boot + vue 候鸟监测数据管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot + 爬虫 高考志愿智能推荐系统(论文+PPT)",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring mvc和mybatis的食品商城系统视频",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot + vue 物流系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "spring boot + vue 雅妮电影票购买系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java 建筑工程项目管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "web学校课程管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot旅游管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java共享经济背景下校园闲置物品交易平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "唐山驰风丰田4s店卖各种各样的丰田汽车",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "南皮站化验室",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java大学生心理咨询平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于图像识别与分类的中国蛇类识别系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java校车管理信息系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "实验室研究生信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot在线智慧考公系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Springboot vue的小区物业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的助农电商平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "亿时网上书店系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "时尚美妆电商网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学校学报出版发行管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java教育资源共享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb宿舍管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot+Vue技术的湖南特产销售网",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "极速”汽车美容与保养网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "就业系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的租房系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的中老年人文化活动平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java教务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图书推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java学生选课系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "JavaWeb图书管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的城市公交管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=173&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的企业客源关系管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=174&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "spingboot茶文化推广系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=175&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java Offer资讯交流Web系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=176&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "仓库管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=177&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java餐品美食论坛",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=178&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java毕业生就业推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=179&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java基于web的医疗设备管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1AaWpe9EcP?p=180&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微格教学视频标注系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学业帮扶管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "考研族租房网站",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "酒店客房预定管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "莲湖小区疫情物资管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "东风锻造有限公司重大停管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的汽车销售系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "就业信息管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM架构的网上书城系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课堂教学效果实时评价系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业仓储管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "泉文化管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "毕业生生活用品出售网站系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JSP的人才招聘网站",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园办公室报修管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "人体健康信息管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "青少年体质健康数据管理与分析系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "游戏售卖网站(论文)",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "有机蔬菜商城",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "超市进销存管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园网书店",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "尤文图斯足球俱乐部网上商城系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "古诗词数字化平台",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校校园招聘服务系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线图书管理",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "专业实习网站",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线商品管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电影购票系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "黄河交通学院教学质量评价系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java乾美美容院管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上宠物店",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "计算机考试系统设计",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情防控志愿者管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "篮球系列网上商城设计与实现",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于微信小程序的大学校园失物招领系统",
    "desc": "微信小程序(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot基于springboot+vue的大学教师考核管理系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm具有推荐功能的二手交易平台小程序设计与实现",
    "desc": "微信小程序(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于校园应用开发校园二手交易平台设计",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "安心陪诊微信小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于校园应用开发校园二手交易平台",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "巴马旅居养老小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农村事务管理与交流平台",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的学生运动打卡系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "线上约拍系统小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的多人协同办公系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健康饮食管理微信小程序",
    "desc": "微信小程序(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "面向品牌会员的在线商城微信小程序微信端演示",
    "desc": "微信小程序(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的校园食堂订餐服务系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的食堂菜品查询平台",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的PS社区",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的家具商城系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序的学生选课系统",
    "desc": "微信小程序(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序二手平台开发",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的一生必去的五十个旅游景点系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java校园二手交易平台",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生心理疏导防控小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区讯息服务小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的九江农产品专销平台",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的生鲜订购系统小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的河湟文化宣传系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小程序适老化背景下老年人康养知识线上学习平台建设",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的南昌旅行指南",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的智慧物业管理系统python",
    "desc": "微信小程序(django)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的食堂点餐系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的智慧物业系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的智慧校园微信小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "蜀味道江湖餐饮管理系统小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的学生寝室管理系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序的流浪动物救助领养平台",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的移动学习平台的研究与开发",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园跑腿小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "乡村医疗上门服务预约平台微信小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区论坛系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小程序 旅游自助拼团系统",
    "desc": "微信小程序(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的任务打卡系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的微信小程序自习教室管理系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序昆明地区宠物领养平台",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java校园二手交易平台",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业内部订餐小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信的社区食堂小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序“遇见宠爱”宠物业务系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的急救常识学习系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "奢旅圈小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序线上水果店系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健康饮食小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线练习小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot付费选座自习室小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的高新学院学生学业管理系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "植物园管理小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的秦兵马俑博物馆小程序",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java横塘小学学生托管管理系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的志愿服务管理系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序健康管理系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "东风锻造有限公司点检管理系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的“健康食谱”食材搭配管理系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的酒店管理系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的家教服务平台",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Javaweb的物流管理系统(论文)",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课程智能组卷系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的淘宝屋购物商城",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "五台山景点购票系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的智能台球厅系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "django食堂外卖系统",
    "desc": "Python+Django",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "django用Python设计学生成绩管理系统",
    "desc": "Python+Django",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "python电影数据分析及可视化系统建设",
    "desc": "Python+Django",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于python的抑郁症患者看护系统",
    "desc": "Python+Django",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Python爬虫的网络小说数据分析系统",
    "desc": "Python+Django",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "django基于python技术的学生管理系统的设计与开发",
    "desc": "Python+Django",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "django疫情计算机分析系统",
    "desc": "Python+Django",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于PHP的高校毕业生就业服务平台",
    "desc": "PHP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上书城设计与实现",
    "desc": "PHP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于农商信息交流平台",
    "desc": "PHP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "nodejs飞鸽旅游服务管理系统",
    "desc": "PHP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于node.js和vue的游戏点单陪玩系统",
    "desc": "PHP",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue的老年医疗服务平台",
    "desc": "Net",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "掌上党支部党员appp",
    "desc": "App(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "英语学习APP（安卓）",
    "desc": "App(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "轻餐饮点餐APP皮皮虾",
    "desc": "App(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Andriod技术“厕ce”APP",
    "desc": "App(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Android的助农系统",
    "desc": "App(SpringBoot)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "爱心小屋公益机构智慧管理APP",
    "desc": "App(ssm)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Android的实时健康感知系统",
    "desc": "App(SpringBoot)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Android的智能考勤系统",
    "desc": "App(SpringBoot)",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于个性化推荐的外卖点餐系统",
    "desc": "App",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "移动端物流系统（安卓手机端）",
    "desc": "App",
    "path": "https://www.bilibili.com/video/BV1VNW8exEHs?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“非学勿扰”学习交流平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "博物馆文博资源库系统设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "餐饮连锁店管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "程序设计基础课程辅助教学系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生心理测评与分析系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "多彩吉安红色旅游网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "二手物品交易系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "复兴村医疗管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高考志愿智能推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校创新创业课程体系",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校网上缴费综合务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个人公务员考试管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个性化旅游推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的嗨玩旅游网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "洪涝灾害应急信息管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于 javaee 的超市外卖系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于 springboot +vue 的实践性教学系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于 SpringBoot 的食物营养分析与推荐网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaWeb的宠物救助及领养平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb的在线购物平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的车辆保险理赔平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的高校毕业生就业信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的高校社团管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的校园二手物品交易系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的校园自助洗衣服务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的招聘求职系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java语言的医疗设备管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于MyBatis的在线车辆租赁信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的古城景区管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的企业员工管理设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的软件学院学生成绩管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的同城宠物照看系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的学生在线训练考试系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot扶贫助农系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot和Vue的美容店信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot护肤品推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot框架药品购买系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot装修公司管理平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+vue 的母婴护理知识共享系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的软件产品展示销售系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的甜品店管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的校园篮球联赛管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的志愿者招募管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot+vue社区老年人帮扶系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的宠物寄领养网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的高校电动车租赁服务业务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的哈利波特书影音互动科普网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的健身房管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的口腔诊所系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的某学院兼职平台设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的青少年心理健康教育网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的社区居民诊疗健康管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的体育购物商城",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的图书管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的文物管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的校园社交平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的校园招聘网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的游戏创意工坊与推广平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的智慧医疗采购系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring的留学信息推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring和vue的食品厂管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue+SpringBoot的考研学习分享平台设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue的花店管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的“畅享”黄山旅游网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的毕业设计选题系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的积分制零食自选销售平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的留守儿童网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的数学题库管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的心理健康交流系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的医院挂号预约管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的助农商超网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于推荐算法的图书推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于推荐算法的在线课程推荐系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的煤矿员工健康管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的的儿童图书推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于学科门类的大学生兼职平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于学生兴趣的学习资源推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "酒店管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "考务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "考研互助平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "考研资讯系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "流浪猫狗救助系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "鹿幸公司员工在线餐饮管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业档案管理信息系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业员工薪酬管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "汽车配件销售管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "人才公寓管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "人工智能领域复合型人才校企协同培养管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "仁和机构的体检预约系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "融合多源高校画像数据与协同过滤算法的高考择校推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "软件技术交流平台设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "数据驱动的资产管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "拖恒ERP物资管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "物流管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "物业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "西山区家政服务网站设计与开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "线上考试系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小区物业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小说阅读平台的设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小学家校互联平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小学生古诗词学习软件",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园失物招领系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生宿舍管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "阳光幼儿管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "瑜伽体验课预约系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧点餐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能宾馆预定系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中小学生成长档案管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校师生工作室管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微服务架构的巡游出租管理平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校毕业生实习及就业去向信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的城市公交查询系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的交通旅游订票系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的流浪动物救助系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的房屋租赁系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的航空散货调度系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的流浪动物管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "旧物回收管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的城乡商城协作系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的学业跟踪评价系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社团管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生宿舍水电信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院预约挂号系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“腾达”游戏分享网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“西贝”小说网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "桂林旅游网站系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "洪涝灾情应急物资管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的医院食堂订餐系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院药品管理系统",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于bs的企业合同管理系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS结构的水电管理系统设计与实现",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的流浪动物救助系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的课程实验教学项目管理系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的老年群体安全用药管理系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "旅游推荐系统的设计与开发录像",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于 SSM 框架的医院人力资源管理系统的设计与实",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java web的大学生兼职网站",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JSP的高校科研项目信息管理系统设计与实现",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM+VUE的智慧出租管理系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的网上鲜花销售系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的养老院管理系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的动漫网站",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "慢性病患者跟踪治疗信息管理系统",
    "desc": "SSM+Vue",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业人事管理系统的开发与实现",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "青少年信息学奥林匹克竞赛交流平台",
    "desc": "SSM+JSP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Python的期货程序化交易系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "django宠物服务管理系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "django基于Django的二手电子设备交易平台设计与开发",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Django的个性化餐饮管理系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Django花卉商城系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Django基于Django框架学习资源推送系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "django基于Python Web的社区爱心养老管理系统设计与实现",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Python的电影票房数据分析系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Python的可视化学习系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Python的农产品销售系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于python的学生考勤管理系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤的音乐推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的的儿童图书推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于python 语言的酒店推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社会主义核心价值观视角下电商平台型社会责任评价研究",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "西西家居全屋定制系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Asp.net的客多多零食购物网站",
    "desc": "Net",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于C#的学生信息管理平台设计与实现",
    "desc": "Net",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "某高校社交学习平台",
    "desc": "Net",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线照相机销售系统",
    "desc": "Net",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "nodejs网球场地管理系统",
    "desc": "Node",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于php的小说阅读系统",
    "desc": "PHP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于PHP的新闻管理系统",
    "desc": "PHP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的新闻推荐系统",
    "desc": "PHP",
    "path": "https://www.bilibili.com/video/BV1vU4revEca?p=173&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Python的王者荣耀战队的数据分析系统设计与实现",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大数据技术的智慧居家养老服务平台",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电影数据分析及可视化系统建设",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于django的民族服饰数据分析系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Hadoop 的国产电影数据分析与可视化",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Hadoop的NBA球员大数据分析与可视化",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Hadoop的图书推荐系统设计与实现",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Hadoop的个性化图书推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大数据的电脑硬件推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于python的白酒数据推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Python的电影票房数据分析系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于python的电影天堂计算机",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Python对b站热门视频的数据分析与研究",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Python爬虫的网络小说数据分析系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spark的短视频推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spark的共享单车数据存储系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spark的温布尔登特色赛赛事数据分析预测及算法实现",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大数据的电子健康信息记录分析系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大数据的音乐推荐系统设计与实现",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大数据技术的电影推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大数据技术的共享单车数据分析与辅助管理系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大数据架构的就业岗位推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于数据挖掘技术的线上招聘信息分析",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤的动漫推荐系统设计与实现",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的电影个性化推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的经济型酒店推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的美食推荐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的校园食堂订餐系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于数据挖掘的广州招聘可视化分析系统",
    "desc": "Python",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小动物救助领养小程序",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农产品扶贫助农系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图书馆预约与占座小程序",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宠物之家小程序",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于uniapp的简易旅行设计与实现1",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于uniapp的校园二手书籍交易平台",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于uniapp的有机农产品电商平台",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于企业微信的工作考勤系统视频",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于企业微信的问卷系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的“美好食荐”系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的餐饮点单系统设计与实现",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的高校实验室管理系统设计与实现",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的高校校园微活动系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的旧衣回收系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的空巢老人健康管理系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的农产品交易平台",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的人才招聘系统设计与实现",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的实验室考勤管理系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的食堂预约点餐系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的手机银行系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的宿舍报修系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的停车场管理系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的云校园",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "面向小学生的阅读交流系统",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信美食点餐系统小程序",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园二手书交易微信小程序",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生服务平台",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "助眠小程序视频",
    "desc": "WeiXin",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生心理健康APP系统的设计与开发",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校教师答疑app的开发",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "红色文物APP",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Android的华蓥山旅游导航系统",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Android的旧物交易平台",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Android系统的旅游攻略APP",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的宠物店线上运营系统",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于安卓Android的校园失物招领",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于安卓的酒店管理APP",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于安卓的团购系统",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于安卓的校园快递互助平台APP",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "琅琊山景区智能导览系统",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能宾馆预定系统",
    "desc": "APP",
    "path": "https://www.bilibili.com/video/BV1RE44efEmj?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的在线拍卖平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的图书个性化推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的网页时装购物系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的学生心理咨询评估系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的网上订餐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的房屋租赁系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的大学生入学审核系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的课程作业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的社区团购系统设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的旅游网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的校园管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的在线视频教育平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的房产销售系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的学生宿舍管理系统的设计与开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的企业客户管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的网上超市",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上点餐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的房屋租赁系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的网上购物商城系统研发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的小徐影城管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线商城系统设计与开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学科竞赛管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的网上租赁系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web足球青训俱乐部管理后台系统开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区医院信息平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的“衣依”服装销售平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "美容院管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新闻推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "古典舞在线交流平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园资料分享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线教育系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "星之语明星周边产品销售网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "旅游管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宠物咖啡馆平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "飘香水果购物网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "服装生产管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教学资源库",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "洗衣店订单管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "美发门店管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课程答疑系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于、B2B平台的医疗病历交互系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "知识管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校学科竞赛平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "人事系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中小型医院网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "视频网站系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的大创管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的图书进销存管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaWeb技术的在线考试系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "车辆管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能物流管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电影评论网站系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的智慧社区设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "民宿在线预定平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "信息化在线教学平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "房屋租赁管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线宠物用品交易网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的论坛网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "靓车汽车销售网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生评奖评优管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的酒店客房管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生宿舍信息的系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的租房管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生竞赛管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的网上摄影工作室的开发与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot大型商场应急预案管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot精准扶贫管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot校园社团信息管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot基于web的音乐网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot抗疫物资管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot学生网上请假系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot基于保信息学科平台系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot大学城水电管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "海滨学院班级回忆录",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot精品在线试题库系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot新闻稿件管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot作业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot在线教育系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Spring Boot技术的卓越导师双选系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot健身房管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于多维分类的知识管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot城镇保障性住房管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot基于java的教学辅助平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的企业资产管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot共享汽车管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于工程教育认证的计算机课程管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot企业级工位管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot编程训练系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot框架的网上商城系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot中药实验管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot汽车资讯网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot疫情下图书馆管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Springboot技术的实验室管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot中小企业人事管理系统代码",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot社团管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot企业oa管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot公司日常考勤系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot在线课程管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot英语知识应用网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=199&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot林业产品推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot人口老龄化社区服务与管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot欢迪迈手机商城设计与开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot宠物领养系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "华强北商城二手手机管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot体育馆使用预约平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot夕阳红公寓管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot新冠病毒密接者跟踪系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的在线家具商城设计与实现--论文pf",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于mvc的高校办公室行政事务管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的在线问卷调查系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的可盈保险合同管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot校园失物招领系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "江理工文档管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot智慧图书管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的贸易行业crm系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的人力资源管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot的的学生干部管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot相亲网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot智能无人仓库管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA语言的在线考试与学习交流",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot+Vue的常规应急物资管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot的线上辅导班系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的医院资源管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "景区民宿预约系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区智慧养老监护管理平台设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的公交线路查询系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "体育馆管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot美食推荐商城",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot党员教育和管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "科研工作量管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot纺织品企业财务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院后台管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot+vue的疫情隔离管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的工厂车间管理系统的设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图书电子商务网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot社区医院管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "二手车交易系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot疫苗发布和接种预约系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疾病防控综合系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot图书管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的装饰工程管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot健身房管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot智能学习平台系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=173&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb的流浪宠物管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=1774vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的医院挂号就诊系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=175&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的乐享田园系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=176&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的网上服装商城",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=177&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的公寓报修管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=178&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园网上店铺",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=179&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue.js的客户关系管理系统(crm)",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=180&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot人格障碍诊断系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=181&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区养老服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=182&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的校园商铺管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=183&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot电商平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=184&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "工作流程管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=185&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot教师工作量管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=186&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot中国陕西民俗网",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=187&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot的秒杀系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=188&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的医药管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=189&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot文理医院预约挂号系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=190&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot高校教师科研管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=191&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot的毕业设计系统的开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=192&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的智能家居系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=193&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot疫情打卡健康评测系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=194&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot个人博客系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=195&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot的论坛系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=196&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot善筹网（众筹）前后台实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=197&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot医疗挂号管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1V7421f7DB?p=198&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot在线考试系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生智能消费记账系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农商对接系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的实习管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot物流管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的大学生一体化服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Springboot开发的精简博客系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医疗报销系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot球队训练信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot大学生心理健康管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "媒体素材库的开发与应用",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "美食烹饪互动平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot新闻资讯系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot志同道合交友网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的医院药品管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的网络海鲜市场系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot+Vue周边游平台个人管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot酒店管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生网上选课系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的信息技术知识竞赛",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot搭建的疫情管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springBoot政府管理的系统设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot经方药食两用服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot旅游管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot高校教师电子名片系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业员工薪酬关系系统的设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot在线远程考试系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot+Vue的乡政府管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot青年公寓服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot大学生就业需求分析系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的疗养院管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的房屋交易平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot在线课程管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "毕业设计成绩管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot光影视频",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "华府便利店信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Spring boot的名城小区物业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的电商应用系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的失物招领平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小学生身体素质测评管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot+VUE技术的智慧生活商城",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot科研项目验收管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot老年一站式服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot人事管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot校园资产管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot在线互动学习网站设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot智慧校园之家长子系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot-vue的毕业论文管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Springboot+vue的餐饮管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot社区养老服务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot小区团购管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的疫情信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot+vue的游戏交易系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SpringBoot的中山社区医疗综合服务",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "流浪动物救助网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot交通管理在线服务系统开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot火锅店管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校专业实习管理系统的设计和开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot的小型诊疗预约平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot263校园组团平台（无论文）",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "JAVA民族婚纱预定系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的库存管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Web的农产品直卖平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生科创项目在线管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot码头船只货柜管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot反欺诈平台的建设",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "JAVA的社团管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "制造装备物联及生产管理ERP系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot车辆管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "JavaWeb的宠物商城网站设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的电影院购票系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "毕业就业信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "JS的个人云盘管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot流浪动物管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaWeb的鲜牛奶订购系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb的影院订票系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于WEB的旅游推荐系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot旅游网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的机动车号牌管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot图书商城管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "HTML5的问卷调查系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Javaweb药店管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "入校申报审批系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaEE的校园二手书交易平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS的老年人体检管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的房地产销售管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot教学资料管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot校园疫情防控系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园外卖服务系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb的学生用品采购系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java的火车票订票系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "商业辅助决策系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于个性化定制的智慧校园管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "毕业生实习与就业管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot计算机学院校友网",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java的家政服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "线上医院挂号系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于html5的网上团购系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的汽车租赁系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "针对老年人的景区订票系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于html5的民谣网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的银行账目账户管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的民宿管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue的MES生产制造执行系统",
    "desc": "源码+数据库+PPT+任务书+论文+说明文档",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的汽车销售系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web手工艺品销售系统的开发与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的小区物业智能卡管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "精品水果线上销售网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=198&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "安康学院新型冠状病毒肺炎疫情防控专题网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java无人超市管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web教师个人成果管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社团服务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于HTML语言的环保网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "绿城郑州爱心公益网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS的社区物业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的校园服务平台设计与开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情期间高校人员管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的美妆购物网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电影订票及评论网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的企业OA管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园体育场馆（设施）使用管理网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的医院急诊系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线骑行网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "数计学院学生综合素质评价系统的设计与开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "付费问答系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“有光”摄影分享网站系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot养老院管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java Web的考编论坛网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "仓库管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "足球社区管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区物资交易互助平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园失物招领系统 -没演示视频后续更新",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "it职业生涯规划系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "javaweb的新能源充电系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“共享书角”图书借还管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot+vue校园求职招聘系统设计和实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生双创竟赛项目申报与路演管理系统_0f6p9",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生选修选课系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Hadoop的物品租赁系统 9349a",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java敬老院管理系统2023_35806",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring的高校实习信息发布网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的铁路订票管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大数据的智能家居销量数据分析2023_jr986",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的黔醉酒业白酒销售系统_p091v",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "人事管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "同城上门喂遛宠物系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "无人智慧超市管理系统_niyfl",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "物业管理系统_78ahx",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "足球俱乐部管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "助农管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "助农产品采购平台设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中小型制造企业质量管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧社区居家养老健康管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧草莓基地管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "志愿服务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "招生宣传管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线租房和招聘平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校竞赛管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校科研信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校疫情防控web系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校物品捐赠管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校汉服租赁网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校毕业与学位资格审核系统_zpl96",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校教师教研信息填报系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校宣讲会管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校实习管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校危化试剂仓储系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "驾校预约学习系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "预报名管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "项目申报管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "面向智慧教育的实习实践系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "集团门户网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "陕西理工大学奖学金评定管理系统的开发boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=173&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "防疫物资管理信息系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=199&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "闲置图书分享boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=174&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "银行客户管理系统代码",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=175&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "辽B代驾管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=176&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "西安旅游系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=177&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "药品管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=178&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "艺体培训机构业务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=179&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "船运物流管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=180&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "船舶维保管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=181&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "船舶监造系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=182&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线装修管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=183&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "员工健康管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=184&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "狱内罪犯危险性评估系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=185&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "瑜伽馆管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=186&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情物资管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=187&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情居家办公系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=188&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "一站式家装服务管理系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=189&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "养老保险管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=190&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "研究生调研管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=191&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "牙科就诊管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=192&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学校防疫物资管理平台boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=193&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生选课系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=194&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "航班进出港管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=195&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "考研互助交流平台springbootlod和php",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=196&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "考勤管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1FU411f7UV?p=197&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "考务报名平台论",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "美术馆管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "美发管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上商品订单转手系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "纹理生成图片系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "粮仓管理系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "箱包存储系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "笔记记录分享网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "福泰轴承股份有限公司进销存系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区防疫物资申报系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区网格化管理平台的构建",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区疫情返乡管控系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区疫情管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区待就业人员信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区帮扶对象管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区医疗服务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区医疗服务可视化系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "甘肃旅游服务平台代码",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "玩具租赁系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "爱心商城系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "滑雪场管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "水产养殖系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "民航网上订票系统设计和实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt/?p=713&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "武汉君耐营销策划有限公司员工信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校运会管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园食堂订餐系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园竞赛管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园疫情防控系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园疫情防控管理系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园疫情防控信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园生活服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园招聘系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园悬赏任务平台boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园志愿者管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园健康驿站管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "果蔬作物疾病防治系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "本庄村果园预售系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "日常办公用品直售推荐系统_02i27",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "旅游管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新冠物资管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新冠物资管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "数字化农家乐管理平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教师薪酬管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教学辅助系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教学资源共享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "房屋租赁管理系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微乐校园",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "当代中国获奖的知名作家信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "工资信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "工作量统计系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "山西大同大学学生公寓管理系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小型医院医疗设备管理系统boot",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小型企业客户关系管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家教管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "客户管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "实习生管理系统设计和实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生成绩分析和弱项辅助系统设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生心理压力咨询评判",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生信息管理系统论文_20230609_075750",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生计算机基础网络教学系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生平时成绩量化管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生就业服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生在线租房平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生创新创业项目管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大数据的心脏病患者数据分析",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的东北特产销售系统的实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法商品推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web网上村委会业务办理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的物流管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的垃圾分类回收系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的喀什旅游网站设计与开发_hw31x",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue篮球联盟管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue技术的农业设备租赁系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue全家桶的pc端仿淘宝系统_kebgy",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的高校电动车租赁系统_hb0fi",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot高校就业招聘系统设计和实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot社区老人健康信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的校园失物招领系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的扶贫助农系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的宠物健康顾问系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的太原学院商铺管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的城市垃圾分类管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的乡村政务办公系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的七彩云南文化旅游网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot vue的影院购票系统录像",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于spring boot的餐厅点餐管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java线上历史馆藏系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的美食信息推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的综合小区管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的物资综合管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java手机销售网站设计和实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java国产动漫网站设计和实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb的城乡居民基本医疗信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于html5＋css3的在线英语阅读分级平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的课程设计选题管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于WEB的牙科诊所管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Sringboot+Vue个人驾校预约管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Springboot网上蛋糕售卖店管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的网上宠物店系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的小区疫情购物系统录",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Springboot教学管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Springboot宠物商城网站系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Springboot和BS架构的宠物健康咨询系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Springboot+vue线上教育培训办公系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot视频点播系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的私房菜定制上门服务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的宽带业务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的家电销售展示平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的宠物爱心组织管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的学生网上选课系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的高校线上心理咨询室",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue疫情物资捐赠和分配系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring boot的社区医院管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的民宿租赁系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的校园闲置物品交易系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的律师事务所案件管理系统的设计与开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的大学校园生活信息平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于MVC模式的红色革命文物征集管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于MVC框架自习室管理和预约系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的大学生考勤系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java企业项目管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Javaweb的项目申报系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaWeb的本科生交流培养管理平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的流浪动物救助平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS模式的冷链物流系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于 html5 的图书管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图书管理系统900",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "售楼管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "可信捐赠系统的设计与开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "协同过滤电影推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农产品智慧物流系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农事管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "兴顺物流管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "公司资产网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "党员学习交流平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健身房管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健康医院门诊在线挂号系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "停车场管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "供应商管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业内管信息化系统论文",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "产业园区智慧公寓管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "二手物品交易boot代码",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "乡村养老服务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "乐乐农产品销售系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "三国之家网站设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能停车计费系统设计与实现_urqs9",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot智慧养老中心管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的计算机学习系统代码.rar",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院档案管理系统代码 .rar",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的考试系统代码",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的动物领养平台设计与开发代码",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "实训管理系统修改后代码(1)",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "线上学习资源智能推荐系统boot代码",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "车险理赔信息管理系统修改代码",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "金帝豪斯健身房管理系统设计与实现修改权限",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "销售项目流程化管理系统代码 .rar",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业车辆管理系统设计与实现 .zip",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot健美操评分系统_o4o1y",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot养老院管理系统_1w568",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot医院病历管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot图书管理系统_g9e3a",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot在线小说阅读平台_0hxfv",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot基于协同过滤算法的私人诊所管理系统_6t4o8",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot学院个人信息管理系统_21j0r",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot宿舍管理系统_o4dvi .zip",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot智能菜谱推荐系统_ct3p7",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot校园一卡通_q7e7o",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot校园便利平台_1jxhb",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot校车调度管理系统_r4le2",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot武理多媒体信息共享平台开发_s2uq7",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot汽车服务管理系统 _od8kr",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot汽车租赁管理系统_1ma2x",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot流浪猫狗救助救援网站_4a4i2",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot社区团购管理系统_975sz",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=173&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot科研管理系统_2byeq .zip",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=174&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "一款基于BS的美食网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=175&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个性化电影推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=176&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业内部小型网络管理系统.zip",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=177&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健身俱乐部网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=178&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "儿童性教育网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=179&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图书大厦图书管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=180&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线学籍管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=181&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线考试系统研究与实现_iq653",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=182&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Hadoop的高校固定资产管理系统研究与实现_hot14.zip",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=183&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的大学生迎新系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=184&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的小区物业管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=185&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Layui和SpringBoot动漫商城管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=186&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的智慧社区管理系统_2p760",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=187&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的来访管理系统-",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=188&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的雪具销售系统_x9zss",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=189&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的在线政务服务中心",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=190&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于VUE的农产品预售平台设计_v8557",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=191&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue.js高校学生选课系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=192&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的就业管理系统_w3209",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=193&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的电子产品销售系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=194&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的视频及游戏管理平台的设计及实现_0816q",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=195&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的个性化图书推荐系统_1k4p4",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=196&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java语言的考试信息报名系统_5n9zn",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=197&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot框架的电影订票系统_wqc3k",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=198&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的公益服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Mf421178b?p=199&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的影城会员管理系统_ih133",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的招聘系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的旅游出行指南_655ms",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的网购平台管理系统_0q1i3",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的多媒体素材管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法的体育商品推荐系统_t81xg",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微服务的车联网位置信息管理软件",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于文学创作的社交论坛",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于疫情防控管理系统的计算机分析与实现_3mkgh",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大健康养老公寓管理系统_to14d",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学新生报到系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生创新创业训练项目管理系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "失踪人员信息发布与管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生信息管理系统_06bg9",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生宿舍管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宿舍维修管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧党建系统设计与实现_1i659",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧医疗服务平台_087z7",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧学生校舍系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "档案管理系统_g2p7x",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "榆林特色旅游网站_8f7p0",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "洋州影院购票管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "热门网游推荐网站的设计与开发_s5832",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "物流信息管理系统_ho5g5",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "画师约稿平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "私人西服定制_0le12",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "膳食营养健康网站_4d8g9",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "西安工商学院课表管理系统_2n594",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课表管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "饮食分享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "驾校管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校学生饮食推荐系统_02187",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot“漫画之家”系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot班级综合测评管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot大学生就业服务平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot大学生体质测试管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot电子招投标系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot高校食堂移动预约点餐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot基于SpringBoot+Vue的冬奥会科普平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot基于Web的社区医院管理服务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot家乡特色推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot家政服务管理平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot留守儿童爱心网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot农机电招平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot乒乓球预约管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot摄影跟拍预定管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot私人健身与教练预约管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot校园在线拍卖系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot学生成绩管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot医院信管系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot智慧党建系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "sprinmgboot实习管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线考试",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java学习平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot4S店车辆管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot学生综合成绩测评系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "springboot学生综合测评系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“智慧食堂”设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "一起来约苗系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "乐校园二手书交易管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "书籍学习平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "人事管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业客户信息反馈平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "休闲娱乐代理售票系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "会员制医疗预约服务管理信息系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "体育场馆运营",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "分布式架构网上商城",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医患档案管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院固定资产系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "原创歌曲分享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线外卖系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线小说阅读平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "地方废物回收机构管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的超市进销存系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Spring Boot的在线考试系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的CSGO赛事管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringBoot+Vue的漫画网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的MOBA类游戏攻略分享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的地方美食分享网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的智慧养老平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于协同过滤算法商品推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生租房系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生就业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生考勤管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生选课系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家具商城系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小学家校一体“作业帮”",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "就业信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "广场舞团",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "应急救援物资管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "招生管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "招聘信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "数码论坛系统设计与实现",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "时间管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧外贸平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能热度分析和自媒体推送平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校友社交系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园交友网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园医疗保险管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园台球厅人员与设备管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园志愿者管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园疫情防控系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "桥牌计分系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "沁园健身房预约管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "游戏分享网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "生鲜交易系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "生鲜超市管理",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情防控期间某村外出务工人员信息管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫苗接种管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区疫情防控平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "福聚苑社区团购",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "篮球竞赛预约平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "篮球论坛系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "线上买菜系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "结合疫情情况的婚恋系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上书城",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上图书商城",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网吧管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "自媒体社区平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "致远汽车租赁系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "藏区特产销售平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "财务管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "车辆充电桩",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "逍遥大药房管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "驾校管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校党务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园新闻管理系统的设计与开发",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“闲一品”交易平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "毕业生信息招聘平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "餐厅点餐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "二手交易平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "职称评审管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "简历系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "旧物置换网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "论坛管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "旅游管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "汽车租赁系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "人职匹配推荐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区维修平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上商城购物系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小区物业管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园新闻网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新生宿舍管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生毕业离校系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情网课管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "影城管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "幼儿园管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "准妈妈孕期交流平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "自习室预订系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "租房网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "点餐平台网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线动漫信息平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家具销售电商平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教师人事档案管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "考研资讯平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "口腔管家平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "垃圾分类网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "旅游管理系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "火车订票管理系统-没演示视频后续更新",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "体质测试数据分析及可视化设计",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "外卖点餐系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园博客系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园闲置物品交易网站",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园闲置物品租售系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园疫情防控系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "心灵治愈交流平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医疗服务系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院急诊系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "音乐翻唱与分享平台",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线BLOG网",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线答疑系统",
    "desc": "SpringBoot+Vue",
    "path": "https://www.bilibili.com/video/BV1Cb421b7Gt?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校专业信息管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学院党员管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm在线医疗服务系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm新生报到系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java的少儿编程网上报名系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "亚盛汽车配件销售业绩管理统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm医院门诊挂号系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm毕业生就业信息统计系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新能源汽车在线租赁管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "线上旅行信息管理系统ssm+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm医院住院管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小型企业办公自动化系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JSP的乡镇自来水收费系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健身房管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java Web 的校园驿站管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网上花店设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm简易版营业厅宽带系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm社区文化宣传网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于ssm的人才招聘网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm博客系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm房屋租售网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "实验室耗材管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm家政服务网站设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm大学生兼职平台的设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园美食交流系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学校运动会信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "蜀都天香酒楼的网站设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网络游戏公司官方平台设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm小学生课外知识学习网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm社区管理与服务+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "汽车客运站管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm单位人事管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学生请假系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家居商城系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于Java的图书管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm物流管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm汽车养护管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "菜匣子优选系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "安徽新华学院实验中心管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm绿色农产品推广应用网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm在线云音乐系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "龙腾公司员工信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java+mysql多角色学生管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于jsp的精品酒销售管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm人事管理信息系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网上服装销售系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm电子竞技管理平台设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线购物系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm助学贷款+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网上医院预约挂号系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm游戏攻略网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm班主任助理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中小企业人力资源管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "语言校园快递代取系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生公寓管理中心系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm共享客栈管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧城市实验室主页系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM的高校共享单车管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个人博客网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm会员管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "德云社票务系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm农产品仓库管理系统系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大健康综合咨询问诊平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农家乐信息平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm中小型企业财务管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm海鲜自助餐厅系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm端游账号销售管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园代购服务订单管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "北京集联软件科技有限公司信息+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院在线挂号预约系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "彩妆小样售卖商城+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm应急资源管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学生信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园快递一站式服务系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm铁岭河医院医患管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中国咖啡文化宣传网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "云趣科技客户管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "削面快餐店点餐服务系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校实验室管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "斗车交易系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "化妆品配方及工艺管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm的大型商场会员管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm鲸落文化线上体验馆+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园教务系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm会议管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的汽车售票网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "理发店会员管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园活动管理平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园自助洗衣系统的分析与设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Tomcat技术的车库智能管理平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "毕业生就业状况管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学生宿舍管理+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校教师科研信息展示网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm实验室开放管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm人力资源管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "计算机网络课程试卷生成器+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm医学生在线学习交流平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm珠宝首饰交易平台开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“魅力”繁峙宣传网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm宠物领养系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm园区停车管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "JAVAEE技术校园车辆管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生公寓管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm电动车租赁网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农业视频实时发布管理系统设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于jsp的网上手机商城+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm民宿管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "MVC的舞蹈网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "星空游戏购买下载平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm框架的购物网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上拍卖系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm乐购游戏商城系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm临沂旅游咨询系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网络教学平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "亿互游在线平台设计与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm在线购书商城系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "金鱼销售平台的开发和实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm开放式教学评价管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校教学业绩信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上书城系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "田径运动会成绩管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "四六级报名与成绩查询系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于HTML5的出租车管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的乡镇篮球队管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电脑配件销售系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "办公用品管理系统开发与设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于jsp的学生作业管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "保险业务管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院住院综合服务管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的网上药品售卖系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm工贸学生信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm连锁经营商业管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "公司项目管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的微博系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于面向对象的学生事务处理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "选课排课系统的设计与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "奶茶店管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm餐厅点菜管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm视频点播系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园一卡通系统软件+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM的校园二手物品交易平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java的电脑硬件库存管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电子相册系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm旅游攻略网站设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线电影评价系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学生成绩管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm旅游网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm家庭财务管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm前后端分离鲜花销售系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生创新创业平台竞赛管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的公务员培训机构管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于Vue框架的订餐系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业人事管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm框架的大学生就业信息平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "会员制度管理的商品营销系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "web的资源共享平台的共享与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "药房药品采购集中管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm神马物流+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学院学生论坛+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园资讯推荐系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm固定资产管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "实验室考勤管理系统网页的设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于Java的学习交流论坛+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的疫情物质管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业博客网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm旅行社管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "养老院老人健康监护平台设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm开心农家乐系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于web的药品管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "生活缴费系统及相关安全技术+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网络安全宣传网站设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校工会提案管理信息系统的设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生创新创业平台项目管理+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=173&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的线上课程管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=174&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm医用物理学实验考核系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=175&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线作业管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=176&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "影视企业全渠道会员管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=177&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高等数学试卷自动生成系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=178&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm大学学术交流论坛+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=179&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm高校社团管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=180&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm国学文化网站的设计与制作+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=181&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院住院管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=182&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java的在线教育平台设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=183&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm的“游侠”旅游信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=184&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "计算机公共基础课程mooc教学+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=185&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm毕业生就业管理平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=186&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "职工健康每日申报系统设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=187&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm线上学习网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=188&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的小型超市管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=189&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "失物招领信息交互平台的设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=190&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校疫情管理系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=191&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的安全教育平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=192&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm旅游景点管理系统设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=193&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm日用品网站设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=194&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm小区疫情防控管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=195&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm物流管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=196&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于vue的线上点餐系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=197&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "毕业生跟踪调查反馈系统的设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=198&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "流浪狗收容领养管理平台的设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Xs421c73P?p=199&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于SSM的咖啡销售系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM视频播放系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM在线教育网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Vue汽车服务商城系统设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm框架仓库系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于JAVA的校园电子商城+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm+vue的外卖点餐系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情期间高校师生外出请假系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm高校食堂订餐系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小区物业管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "公司人力资源管理系统设计实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "汽车站车辆运管系统开发与设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情期间社区出入管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "一中体育馆管理系统的设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm传统文化网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新锐台球厅管理系统的设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm培训学校教学管理平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区物业管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "金旗帜文化培训学校网站的设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线房屋租赁和电子签约系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于jsp的快递管理系统的开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm闪烁物业管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm图书商城网站的设计和开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM的高校学生综合素质评价系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电子设备销售网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm论文投稿系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm流浪动物领养信息系统设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm点餐平台系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm居家养老系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于HTML5的OA办公系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宠物医院管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "框架的校园招聘系统的设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "酒店预约及管理系统的设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm罪犯信息管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "葛溪乡留守儿童信息管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm航班订票管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校图书馆个性化服务的设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm省出口基地公共信息服务平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm会员卡管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm个性化美食推荐系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm品牌手机销售信息系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "缪斯乐器购物网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "计算机科学与技术学习网站的设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm作业提交与查收系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "国外摇滚乐队交流和周边售卖+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb的吃了吗管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "vue框架技术的漫画网站系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中小学教师进修培训管理系统设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "WEB的开放性实验室管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "模具制造企业订单跟踪管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm毕业设计项目管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宠物用品电子商务平台设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新枫之谷游戏攻略与信息平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm餐饮掌上设备点餐系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园二手交易平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm同学录网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm物资进销存jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的个人通讯录+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于vue的搬家预约系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm宠物店管理平台开发",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "防疫信息登记系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm流浪动物领养系统网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "购物商城网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm社区智慧养老监护管理平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "楚师师生健康管理系统设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于VUE的新闻类网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园二手交易网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm办公自动化管理系统java+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm宠物医院管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm大学学生成长系+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "计算机office课程平台设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线教学质量评价系统的+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm酒店客房管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm本科生导师指导平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的电脑测评系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生学情预警系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校宿舍管理系统的设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“大学生艺术节”管理系统的设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于SSM的旅游管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm电脑公司财务管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm二手车交易网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM的婚恋网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm在线交友系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网上商城系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm生鲜配送系统设计及实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农业信息化服务平台的设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "公务用车管理智慧云服务监管平台",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm广告管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "演唱会购票系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于web的楼房销售系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "双星小区物业管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm汽车租赁系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电动车上牌管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm建筑装修图纸管理平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm图书管理借阅系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM+Vue的随心淘网管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm劳务外包管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Rw4m1Q743?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm社区生鲜电商平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "食用菌菌棒溯源系统的开发与设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm毕业生交流学习平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "自习室预订座位管理分析与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "青海大学昆仑学院学生档案管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm物业管理+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于jsp的网络书店系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "潍坊理工学院就业信息网",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=199&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "汽车租赁系统业务管理子系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm培训机构运营系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生二手书籍交易平台的设计与实",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "水果网上商城的开发与设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm的游戏销售系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中学课内小说阅读与学习系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue和JAVA的生产管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm个人网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java的网络音乐系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的软考系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm课程管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm电子病历系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "javaweb的企业人事信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm房屋租售信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "数据结构课程网络学习平台的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园二手交易平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学生就业管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网月科技公司门户网站开发与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "青大校园预点餐系统的分析与设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm超市库存商品管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网页版电子商城设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm考研图书电子商务平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的微博网站的设计和实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "KTV包厢管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的高校试题管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的健康管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“镜头人生”约拍网站的设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm超市会员（积分)管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网络直播带货查询系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于SSM的宠物领养系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于多层架构的供电所档案管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm新生报道管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "云端学习系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宠物综合服务平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的药店药品销售系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "OA办公管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园二手交易市场+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园停车场管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园服务平台管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm摊位管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园家教兼职信息交流平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm实验室仪器设备管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm员工信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm智慧养老平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "景海中学教学管理系统分析与设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学生疫情信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学餐厅菜品推荐和点评系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "程序设计课程可视化教学系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "软件工程项目管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm设备配件管理和设备检修+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java web的中小型人力资源管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的中小型企业财务管理+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm智能仓储系统研究与设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Web的在线投稿系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "忘忧小区物业管理系统设计与实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java web个人财务管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm星火许电影小说网站设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm“花鸣”B2C电子商务平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "畅玩北海旅游网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm高校实验室资源综合管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的电商网站",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm焦作旅游协会管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm荆州理工职业学院网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm奖助学金管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校医务系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java Web的在线测试管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "供电公司安全生产考试系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校毕业选题管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课程辅助教学平台设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm航帆学院网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于web的网盘管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS架构的学生档案管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm社区生鲜商城+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java Web的在线视频点播系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm工单管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校内互助交易平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园活动资讯网+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm进销存管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm框架网络财务设计与实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm思途旅游管理系统分析与设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于html5的济南旅游网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm课程资源管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS的论文管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm社区团购系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校学生实习管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb的酒店预订管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于vue的电商购物网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "车辆运输管理+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院预约挂号系统+vue带lw",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小区物业管理系统设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的勤工助学系统+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的电子病历管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java web的商铺租赁管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的厨房管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java web的公益网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的客户关系管理系统+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "酒吧存酒系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的进出货管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的个人事务管理系统的设计和实现+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校学生管理系统--论文.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的汽车售后服务管理系统+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "布卡维纳红酒网页的实现+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue.js的连锁干洗店后台管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校实验室信息化综合管理平台建设+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "幼儿资源互助共享平台的设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能小区管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaEE的企业人事管理信息系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课程辅导网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课程案例库平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm框架的智能停车系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学报稿件管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农产品预售平台的设计和实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区疫情联防联控系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "深加工农产品推广服务平台的设计与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网页小游戏交流论坛+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线画展系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的电影订票互动系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "老年公寓管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的地纬公司智能办公系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "经典诗文学习爱好者学习交流平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小区业主服务平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "银行贷款管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农副产品销售网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "物流管理系统开发+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的大学生社团管理系统+vue带lw",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb技术的农作物信息服务平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的在线学习系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue框架的汇美食电子商城+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的职工档案管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的校园综合服务系统+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java Web的线上办公管理系统设计与实现+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的学生宿舍管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS的社区疫情通知通告系统+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的电子书籍敏感字识别系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的水果商城的设计与研究+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的星巴克咖啡店管理系统+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中国文学作品网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaWeb的長安智慧医疗管理系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm+vue的在线听书网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "线上学习平台系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区再就业培训管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "重庆理工大学心理咨询管理子系统的分析与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaweb的疫情管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的二手房中介管理系统+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "实验室管理与排课系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue技术的绿色蔬菜销售管理系统+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue技术的农家乐内部管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的个人课表管理+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网络类课程思政学习系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的学生宿舍维修服务平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的可视化高校公寓管理系统+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "软件开发团队管理网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健身管理系统开发与设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA语言的校园事务自助指南服务系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的小码创客教育教学资源库+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的农产品质量安全检测网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "驾校收支管理可视化平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "咖啡在线销售系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区团购网站+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园失物招领网站的研发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "玉安农副产品销售系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java Web的商城系统+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于jsp的网上商城+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图书管理系统+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue的量化积分管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的学生宿舍门禁信息管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的敏捷工贸公司销售管理系统设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=173&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的高校运动会管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=174&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校就业管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=175&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的微博网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=176&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的校园跑腿管理系统+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=177&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "科研经费管理系统研究与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=178&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能交互式在线网上花店的研发+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=179&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "餐厅点餐系统+vue.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=180&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "服装店销售管理系统+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=181&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校勤工助学系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=182&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的酒店管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=183&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "二手车交易平台的设计+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=184&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "房屋租赁平台的设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=185&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家具销售库存管理信息系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=186&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "淘乐乐员工购物商城+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=187&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "题库管理系统+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=188&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图书管理系统+jsp.rar",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=189&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上茶叶销售平台设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=190&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医药信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=191&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能社区管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=192&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于J2EE的仓库管理系统设计与开发",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=193&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "航空票务推荐系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=194&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Javaee的影视创作论坛的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=195&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的餐馆点餐系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=196&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "经典电影推荐网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=197&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教师办公管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1qJ4m1A7wP?p=198&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "生鲜在线销售系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm职业高中学情成绩系统设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "职业高中智慧作业试题系统设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的网上手机销售系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM的高并发慕课网",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm资产管理信息系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "javaweb的数学竞赛网站",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "VUE的图书馆管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的老年公寓信息管理+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm食品安全追溯系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "物资物流系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园心理健康网站+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的招聘系统设计与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于jsp技术的选课管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于SSM的社区管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "成绩管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "vue框架的点餐系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于冲突动态监测算法的健身房预约",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm教师上课系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm医院交互系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm剧本杀预约系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于SSM实验室排课系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小儿肺炎知识管理系统设计与实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssmOA办公系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "便民自行车管理系统的开发与实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm程序设计实践项目管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "志愿者管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校友录+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaEE的智能实时疫情监管服务",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的游戏资源管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的马病管理系统设计与实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于互联网的音乐电影分享系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "视康眼镜网店销售系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm在线点歌系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm二手商品交易平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java web的鲜花商城系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的图书馆预约占座系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的小区物业管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "蛋糕甜品店管理系统的设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web 的个人时间管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm旅游网页开发与设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm四S店预约保养系统开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的学生在线考试系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的学生资助管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生社团管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "vue框架和elementui组件的手机官网",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "双减后初小教育课外学习生活活动平台",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm智慧社区电子商务系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm框架的滁艺咖啡在线销售系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网络游戏交易平台信息管理系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm班级事务管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于vue搭建的新闻网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于WEB的人事档案管理系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的素材网+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm驾校预约管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网上购物平台设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "《数据库系统原理》课程平台的设",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm毕业设计选题系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "echarts的基金交易网站",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校内信息服务发布系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm企业员工管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm停车管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校园二手交易管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园线上订餐系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm杂志在线阅读网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm教室信息管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm公交车信息管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm好例文共享平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "汽车客运订票系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学生档案管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中小型医院管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm订餐管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "仓库在线管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS架构的法律咨询系统的分析",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的网上订餐管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于Vue的戏剧推广网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "机票管理系统设计与实现（带沙箱支付）",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm社区老年人关怀服务系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网上挂号系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm文化遗产的保护与旅游开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm连锁超市会员管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业人才管理与测评系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网上购物商城+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于BS的项目监管系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于HTML5的交流论坛",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的驾校信息管理系统设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue.js的网上招聘系统设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm流浪动物救助站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "常见小儿疾病中医护理系统的设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校班级同学录网站设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "明水县苹果网吧计费管理系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "线上选课系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于VUE3+SSM框架的在线宠物商城",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的视频播放器",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的毕业生就业管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm框架的校园闲置物品交易平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm社区医疗保健监控系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm阅微文学网站的设计与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java Web的怀旧唱片售卖系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM的游戏商城+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "vue的音乐播放器+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家政公司服务平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "快餐店点餐结算系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学费管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学生社团管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm图书馆书库管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm校内二手商城交易系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个性化旅游攻略定制系统设计与实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网络游戏交易系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于ssm的房源管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "vue.js的购物商场+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "协同过滤技术的网上书城的开发与研究",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "物流配送人员车辆调度管理系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm运动器械购物商城+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "城投公司企业人事管理系统设计与实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大湾区旅游推荐系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java web 的QQ村旅游网站的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "一家运动鞋店的产品推广网站的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm物流信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm图书管理系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于WEB的文学网+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "J2EE开发的猎头公司管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm企业人事管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的二手交易平台设计与开发",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "无纸化学习平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm在线视频网站开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "儿童影楼拍摄管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校智能培训管理系统分析与设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm中医+养老服务平台设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm政府项目管理平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm孩童收养信息管理+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm教材管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm理财通+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm实验室排课系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm框架的博客系统的开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园二手交易平台的设计与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情防控管理系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm框架的车辆出租管理系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue的健身房会员管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于web的电影购票系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "物流配送管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "明嘉新材料公司仓库管理的设计和实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm企业文档管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm疫情期间高校防控系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm游泳会员管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm毕业生学历证明系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java Web的在线电影票购买系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Javaweb的网上花店系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Javaweb的网上奶茶店系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Javaweb的物流信息管理系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "JAVA的校园失物招领平台的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "spring和vue开发的web新闻流媒体",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm框架的少儿编程在线培训系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM框架的宿舍管理系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "SSM的在线学习系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Web的数字家庭网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm教务信息平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "数学课程评价系统的设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网上系统调查的开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的壁纸网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区流浪动物救助领养系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm中文学习系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java Web的学生宿舍管理系统设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的学生考勤管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm课程管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm课程在线教学平台设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学习视频资源库的系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm673疫苗预约系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的酒店客房管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的智能训练管理平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "VUE的儿童教育网站",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm旅社客房收费管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新媒体视域下的中国古诗词展演+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生学籍管理系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的旅游论坛设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm基于Java的超市管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=173&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "JAVA的咖啡馆管理系统设计与实现",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=174&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于VUE.js的在线教育系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=175&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "WEB技术的在线商品交易平台的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=176&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm百货中心供应链管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=177&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java web的高校学生课堂考勤系统",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=178&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java的众惠商城+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=179&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的高校大学生党建系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=180&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Web的课堂管理系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=181&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "江苏融汇房地产营销策划有限公司网站",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=182&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm线上旅游体验系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=183&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm学籍管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=184&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java web的防疫工作志愿者服务平台",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=185&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "Java的药店药品信息管理系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=186&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "java的自助医疗服务系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=187&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SpringMVC网上选课系统的设计",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=188&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web办事大厅政务预约系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=189&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "ssm网络办公系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=190&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生公寓管理系统的设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=191&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java Web贫困认定管理平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=192&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JavaWeb的个人健康信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=193&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的图书管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=194&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生考勤管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=195&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学术团队管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=196&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中小型餐厅网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=197&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "珠江学院大学生自愿者服务网+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1pm421M7y6?p=198&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校宿舍管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS的库存管理软件设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java Web的“萌宠小知识”网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Javaweb的线上招聘问答系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "冀中工程技师校园网站设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园驿站全天候辅助取货管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园体育赛事管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "实验室预约管理+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java 的病房管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的山东红色旅游信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "出租车管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个人日常事务管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "精品课程在线学习系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图书馆智能选座系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "北关村基本办公管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "花卉库存管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java web的住院管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "公司员工工作日志办公系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的宠物医院预约挂号系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的学生就业管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上拍卖系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "航空信息管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的汽车维修保养智能预约系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的音乐产品购物网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的宠物医院信息管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业人事管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小区物业管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区人员管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于javaWeb的高校后勤报修系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的高校物业工程报修系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的游戏后台系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生校园招聘网+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "演出人员与观众疫情信息管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "actual self 服装店+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "白云会议管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的校园报修管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "科技银行业务管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个人消费管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的校园二手物品交易平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于在线开放课程的Web前端设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "普通话培训信息管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "钢铁集团公司安全管理系统的构建与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java Web的医疗系统实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm+vue的中国版Blackboard学习系统实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "影院管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的通讯录管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JSP的高校听课评价系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的快递信息管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的漫画阅读系统的设计与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校外事管理系统的设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于HTML的中国传统面食介绍网站的搭建+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网页商城系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的P2P借贷网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "政务大厅管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS的旅客行李管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "民族大学创新学分管理系统分析与设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生成果登记系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的健身中心管理系统的+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中学生课后服务的信息管理与推荐+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的图书借阅管理系统的设计与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的实验室设备管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小工程预算+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "长安材料批发市场管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个体户商城+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园疫情管控系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的民宿预订管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图片素材网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的的农产品线上销售网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "果蔬商品管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS模式的直播电商交流平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的宠物服务平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "C2C商务网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的体育用品交易网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于bootstrap的课程辅助教学网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM的校园兼职管理系统设计+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的穿戴搭配系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Web的私人定制旅游系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家乡特产网上商城+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于BS的超市商品管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java疫情期间高校人员管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的校园二手物品交易平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm技术的金融支付终端管理系统设计与实现+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的网上房屋中介管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "公司进销存管理系统设计与开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue的线上书籍查阅系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生工作管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "服装品牌的推广及应用网站+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "青年租房管理系统的设计与开发+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Javaweb的小说阅读平台",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的汇编课程网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于MVC构架的网上食品店+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web的音乐管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生奖惩管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "代驾应用系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JSP的游戏虚拟道具交易网站的设计+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的学生宿舍设备报修管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "兰亭序图书管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "心理测评系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的学生网上请假系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于电商平台的用户画像+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "驾考自主学习预约平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课程教学网站设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "西安旅游管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新冠病毒校园监控平台+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教务管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JSP的家纺用品销售管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业在线培训系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校毕业生就业管理系统+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于web技术的税务门户网站的实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "企业员工岗前培训管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JSP的电竞交互管理系统开发+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的心理预约咨询管理系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Java的在线日语培训平台+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "同城蔬菜配送管理系统研究+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm的电影评论系统+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的民宿预订管理系统设计与实现+vue",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的珠宝购物网站系统的建设+jsp",
    "desc": "SSM",
    "path": "https://www.bilibili.com/video/BV1Pt421M7i6?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于小程序的购物系统设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家庭记账本+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教学辅助微信小程序设计+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园水电费管理微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于小程序的老孙电子点菜系统开发设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "优购电商小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院管理系统+Springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信平台的旅游出行必备商城小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "模拟考试+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信阅读小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院核酸检测服务系统开发+Springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的科创微应用平台设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新闻资讯微信小程序开发后端+php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健身管理系统及会员微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于Vue.js的校园防疫微信小程序开发+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信的设备故障报修管理系统设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的学生公寓电费信息管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "实习记录小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教师管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "订餐系统设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA微信点餐小程序设计+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个人行政复议在线预约系统开发+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的童装商城+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "汽车保养系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "移动学习平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信的原创音乐小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小说阅读器+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信阅读网站小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "英语学习交流平台小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "助农扶贫微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电子商城购物平台的设计与开发+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的商品展示+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信课堂助手小程序+php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线课堂微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的4S店客户管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电子竞技信息交流平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "外籍人员管理系统小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "绘画学习平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "私家车位共享系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "居住证申报系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "培训机构客户管理系统的设计+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "消防隐患在线举报系统开发+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的网上商城+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "云上考场+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序电影订票系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园外卖平台设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校体育场管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "畅阅读微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信的乐室预约小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信的乐室预约小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信的追星小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的四六级词汇+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的购物系统+php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "马拉松报名系统微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智能社区服务小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线投稿系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序考试系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "互助学习小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健身房私教预约系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "传染病防控宣传系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "考研论坛设计+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生闲置物品交易平台的分析与设计+ssm（微信端有问题，暂时不卖）",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家政项目小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小区租拼车管理信息系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电影院订票选座小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "计算机实验室排课与查询系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "一次性环保餐具销售系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "汽车预约维修系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "会议发布与预约系统的设计与开发+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧旅游平台开发微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "儿童预防接种预约微信小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家政服务管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "亿家旺生鲜云订单零售系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "停车场微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生知识成果展示与交流+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上商城设计+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "培训咨询微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于移动平台的远程在线诊疗系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序跑腿+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园工会体育报名系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生心理健康服务+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "警务辅助人员管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的影院选座系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区养老服务+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校车购票微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园综合服务小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "体育资讯软件的实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农场驿站平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "二手闲置交易市场+ssmpf",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "南宁周边乡村游微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "图书馆自习室座位预约管理微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网络小说微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的社区团购+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家具购物小程序+php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电子购物系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "外卖小程序的研究与开发+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宠物小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "停车共享小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1Qt421T711?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "旅游社交小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于h5 移动网赚项目设计与实现+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "随堂测微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "文章管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小说实体书商城+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园服务平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园二手交易平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校寻物平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的书橱+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校友会系统的实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健身房私教预约微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园二手数码交易平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "明星应援系统设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "音乐播放器+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生就业平台微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新闻资讯系统设计+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电影院订票选座系统设计及实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宿舍管理系统小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校友林微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "作品集展示微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "无中介租房系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线订餐系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧乡村旅游服务平台+ssmpf",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个人健康数据管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "民大食堂用餐综合服务平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "预约挂号系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线视频教育系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "外卖商城平台的微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "综合文化信息管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家庭事务管理微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "客家菜餐馆点菜系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生活动管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院挂号系统设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "房屋租赁管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "公交信息在线查询系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "外卖点餐+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区互助养老+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线选座+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "二手交易网站设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学习自律养成小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园资讯平台微信小程序+ssm（微信端有问题，暂时不卖）",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "自修室预约系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "驾校管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "专利服务系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "酒店管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序打印室预约+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家庭财务管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "家庭大厨微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "云匹面粉直供微信小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "未知小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "实验室管理微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "阳光电脑公司的维修服务微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高质量阅读微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个人日程安排微信小程序的实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于H5的智慧消防微信小程序设计与开发+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "停车场管理+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健身小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线课堂微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课程答疑微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "博客小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的校园二手交易平台系统设计与开发ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园跑腿php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "展柜设计公司平面布置小程序的分析与设计springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于小程序的社区超市管理系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园失物招领小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“返家乡”高校暑期社会实践微信小程序设计与开发ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的小区疫情防控ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "健身达人微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校学生事务管理系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园反诈骗微信小程序的设计与开发ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的电影院订票选座系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的教学质量评价系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信平台的文玩销售小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序软件缺陷管理系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校教师成果管理小程序springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "澡堂预订的微信小程序的设计和利用ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的在线选课系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "奶茶点餐小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的乡村政务服务系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“黄师日报”平安小程序springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于小程序宿舍报修系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“村游网”系统的微信小程序开发ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "餐厅点餐微信小程序springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的订餐小程序springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "社区二手物品交易小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "中国剪纸微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信的高校教务管理系统设计与实现springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线厨艺平台微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的小区管理系统的设计ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "即时空教室查询小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的社区垃圾回收管理系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校学习助手小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信平台的购物商城小程序开发ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "运动健康小程序SpringBoot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于JAVA的微信食堂线上订餐小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生管理系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的快递管理平台ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的社区车位租赁系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的校园保修系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "便捷饭店点餐小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "婚庆摄影小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信的疫情期间学生请假与销假系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序线上教育商城ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园顺路代送微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "课堂考勤微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的二手物品交易平台ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序投票评选系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序自助点餐系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园约拍微信小程序设计与实现ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "答题小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的考研资料分享系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的水果销售系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序疫苗预约系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信的垃圾分类小程序springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的学生签到系统设计与实现ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“校园资料分享微信小程序”springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序评分小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "英语互助小程序springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新冠肺炎服务预约微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的在线学习系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "球馆预约系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于java的餐厅点餐系统微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的汽车销售系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的新生报到系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的社区门诊管理系统php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的走失人员的报备平台设计ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生资助在线管理软件开发微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫苗预约小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "速达物流信息查询微信小程序设计与实现ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序基于BS模式的学生实习与就业管理系统设计与实现springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序研学自习室选座与门禁系统的实现与开发springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=130&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的中国各地美食推荐平台springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=131&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序点餐系统的设计ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=132&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小程序疫苗预约网站系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=133&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的医院挂号预约系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=134&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的校园二手交易平台ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=135&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序高校订餐系统的设计与开发ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=136&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的校园综合服务平台ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=137&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "外卖小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=138&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的外卖点餐系统设计与实现ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=139&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "垃圾分类小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=140&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "教育培训微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=141&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "食堂校园预约就餐小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=142&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序书店springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=143&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序的高校党费收缴系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=144&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "食堂订餐小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=145&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信社团小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=146&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的跳蚤市场设计与实现ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=147&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "流浪动物救助微信小程序springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=148&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的网约巴士订票平台ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=149&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "懂球短视频微信小程序SpringBoot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=150&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的社团活动助手php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=151&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的手机商城ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=152&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于springboot汽车维修管理系统微信小程序springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=153&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于大学生社团活动管理的微信小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=154&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的课堂点名系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=155&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的医院综合服务平台ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=156&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信平台签到系统springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=157&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学习资料库小程序设计ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=158&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校校园交友微信小程序springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=159&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序跑腿平台ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=160&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小程序插画共享平台ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=161&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的小说阅读系统ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=162&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的在线点餐（堂食）平台ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=163&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信平台的报刊订阅小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=164&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信点餐系统小程序ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=165&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue的青少年科普教学系统平台springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=166&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "客运自助售票小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=167&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "松江大学城就餐推荐系统设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=168&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的医院体检管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=169&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的刷题系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=170&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "车视界小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=171&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信智能招聘小程序设计+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=172&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "优选驾考小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=173&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序医院挂号系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=174&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的体育课评分系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=175&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的场地预约设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=176&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "游戏账号交易微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=177&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小程序国产动漫论坛+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=178&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宠物店商城小程序设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=179&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序校园订餐的设计与开发+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=180&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "同城家政服务+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=181&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信平台健身小助手小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=182&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于SSM框架的童装购买平台微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=183&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "火锅店点餐系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=184&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的宠物寄养平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=185&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的大学生科技竞赛管理系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=186&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "懒人美食帮+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=187&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的家政服务预约系统+php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=188&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的民宿短租系统设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=189&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于vue和微信小程序的校园自助打印系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=190&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网络安全科普系统开发与设计+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=191&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于ssm选课系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=192&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "自驾游拼团小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=193&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的企业职工薪资查询系统设计与实现+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=194&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "研知识题库小程序ssm+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=195&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的高校课堂教学管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=196&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的食堂窗口自助点餐系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=197&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的短视频系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=198&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的付费自习室系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1yx4y1i7wE?p=199&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序的点餐系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=1&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宿舍管理小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=2&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的学生宿舍管理系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=3&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信平台小区服务系统+django",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=4&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "鲜花销售微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=5&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校毕业论文管理系统小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=6&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "驾校报名小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=7&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "面向企事业单位的项目申报小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=8&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "论坛小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=9&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "自助购药小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=10&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "童心党史小程序+django",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=11&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "疫情核酸预约小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=12&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "游乐园智慧向导小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=13&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园订餐小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=14&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园二手交易平台小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=15&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新冠疫苗预约小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=16&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "数学辅导微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=17&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "摄影竞赛小程序+django",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=18&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "捷邻小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=19&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信阅读小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=20&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信点餐系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=21&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序的驾校预约管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=22&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序的英语学习激励系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=23&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序的学生选课系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=24&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序校园失物招领+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=25&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生购电小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=26&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于校园作业反馈的家校联系微信小程序+php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=27&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的高校餐厅食品留样管理系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=28&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的食堂线上预约点餐系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=29&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的青少年素质教育培训系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=30&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的足浴城消费系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=31&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的药店管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=32&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的自习室预约系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=33&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的美容院管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=34&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的电影院票务系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=35&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的电影交流平台+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=36&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院预约挂号系统小程序+php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=37&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医院核酸检测预约挂号微信小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=38&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "同城交易小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=39&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农产品自主供销小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=40&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于小程序的企业产品推广系统+php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=41&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序图书馆座位再利用系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=42&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的智能停车场管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=43&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的游泳馆管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=44&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的学习资料销售平台+node",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=45&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的新生自助报到系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=46&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的新生报到系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=47&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的校园商铺系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=48&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的校园兼职系统+node",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=49&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的书籍销售系统+node",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=50&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "党建工作小秘书+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=51&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "党员之家服务系统小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=52&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个人健康信息管理小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=53&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“最多跑一次”微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=54&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“健康早知道”微信小程序+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=55&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的学生宿舍管理系统+node",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=56&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "语言课学习系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=57&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "超市售货管理平台小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=58&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生党务学习平台小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=59&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生校园兼职微信小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=60&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学生心理健康测评管理系统小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=61&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电器维修系统小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=62&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "电影交流平台小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=63&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校宿舍信息管理系统小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=64&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "个人健康管理系统小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=65&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "贵工程寝室快修小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=66&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "机电公司管理信息系统小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=67&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "音乐播放器小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=68&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "铁路订票平台小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=69&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "美食推荐系统的微信小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=70&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "网上花店微信小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=71&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "流浪动物救助小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=72&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校篮球联赛微信小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=73&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园疫情防控管理平台小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=74&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园快递平台系统(小程序)+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=75&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "校园二手交易微信小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=76&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧物流小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=77&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "智慧物业平台小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=78&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "新冠抗原自测平台小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=79&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "戏曲文化苑小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=80&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序的居民健康监测系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=81&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序养老院系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=82&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "开放实验室预约管理系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=83&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "岳阳市美术馆预约平台小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=84&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小区物业新冠疫情物资管理平台小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=85&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "宿舍管理系统小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=86&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的高校就业招聘系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=87&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的驾校预约平台+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=88&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的超市购物系统代码+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=89&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的小区服务管理系统+springboot(无前端)",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=90&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的实习生管理系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=91&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的公考学习平台+springboot(无前端)",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=92&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序+mysql的经济新闻资讯+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=93&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于uniapp智能小程序商城+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=94&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于uniapp+springboot的校园失物招领系统",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=95&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于J2ee的高校毕业生就业信息系统小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=96&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "在线疫苗预约小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=97&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农场管理系统（小程序）+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=98&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "养老院管理系统（小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=99&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "乡村研学旅行平台 （小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=100&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "汉中茗茶微系统设计与实现修改微信小程序代码+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=101&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "傣族节日及民间故事推广小程序+django",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=102&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农产品商城小程序+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=103&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "“口腔助手”小程序_1171u+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=104&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "使命召唤游戏助手_pzbe0+sprigboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=105&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "农业电商服务系统_30249+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=106&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "医笙小程序设计与前端开发_0d26l+django",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=107&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于C#的教材库存管理软件设计与实现_8d330+.net",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=108&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于小程序的物流管理系统-+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=109&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的上门维修系统_22c7h+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=110&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的仓储管理系统_r275i+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=111&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的付费自习室管理系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=112&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的企业内部员工管理系统设计与实现+php",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=113&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的周边美食推荐系统_2axo8+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=114&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的图书馆座位预约_7kci7+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=115&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的小微金融企业_3539r+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=116&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的居民疫情服务系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=117&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的校医务室健康服务系统_06pr7+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=118&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的电影院票务系统+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=119&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的短文写作竞赛管理系统_r653y+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=120&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信小程序的社区志愿者服务平台 _8xh87+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=121&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于微信微服务架构的汽车租赁系统_zaxzu+springcloud",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=122&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "基于智能推荐的校园社区服务微信小程序_5x8ot+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=123&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "大学校园二手书籍拍卖小程序_1505s+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=124&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "学生毕业管理系统_y65fk+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=125&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "小演员招募小程序的设计与开发_33d98+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=126&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "微信小程序的图书管理系统-论文+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=127&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "生活小助手微信小程序_k1s0l+ssm",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=128&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  },
  {
    "name": "高校学术研讨信息管理系统+springboot",
    "desc": "微信小程序",
    "path": "https://www.bilibili.com/video/BV1eJ4m1A7rQ?p=129&vd_source=b786c0abc4923385181f1b6ed3ed9c8d  "
  }
]